import {
  Center,
  CenterProps,
  Progress,
  Text,
  keyframes,
} from '@chakra-ui/react';

interface ImportLoaderProps extends CenterProps {
  inProgress: number;
  count: number;
  labelTemplate?: string;
}

const pulse = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0.5,
  },
  '100%': {
    opacity: 1,
  },
});

export const ImportLoader = ({
  count,
  inProgress,
  labelTemplate = '{inProgress} of {count} songs imported',
  ...rest
}: ImportLoaderProps) => {
  const progress = (inProgress / count) * 100;

  return (
    <Center position="relative" {...rest}>
      <Text
        position="absolute"
        zIndex={1}
        textColor="M.10"
        fontSize="xs"
        fontWeight="bold"
      >
        {labelTemplate
          .replace('{inProgress}', String(inProgress))
          .replace('{count}', String(count))}
      </Text>
      <Progress
        w="full"
        size="lg"
        value={progress}
        sx={{
          '[role="progressbar"]': {
            bg: 'B.0',
            ...(progress < 100
              ? { animation: `${pulse} 2s infinite linear` }
              : {}),
          },
        }}
      />
    </Center>
  );
};
